import { useEffect, useState } from "react";

interface Lantern {
  id: number;
  hue: number;
  swayOffset: number;
  swaySpeed: number;
  size: number;
}

function Lantern({ lantern, time }: { lantern: Lantern; time: number }) {
  const sway = Math.sin(time * lantern.swaySpeed + lantern.swayOffset) * 15;

  return (
    <div
      style={{
        position: "absolute",
        left: `${(lantern.id / 7) * 100}%`,
        top: "20%",
        transform: `translateX(-50%) rotate(${sway}deg)`,
        fontSize: `${lantern.size}rem`,
        textAlign: "center",
      }}
    >
      <div
        style={{
          color: `hsl(${lantern.hue}, 100%, 75%)`,
          filter: `drop-shadow(0 0 30px hsl(${lantern.hue}, 100%, 60%))`,
          textShadow: `0 0 50px hsl(${lantern.hue}, 100%, 60%)`,
          opacity: 0.95,
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        🏮
      </div>
    </div>
  );
}

export function App() {
  const [time, setTime] = useState(0);

  const lanterns: Lantern[] = [
    { id: 1, hue: 45, swayOffset: 0, swaySpeed: 0.0005, size: 6 },
    { id: 2, hue: 35, swayOffset: 1, swaySpeed: 0.0007, size: 7 },
    { id: 3, hue: 50, swayOffset: 2, swaySpeed: 0.0006, size: 6.5 },
    { id: 4, hue: 40, swayOffset: 3, swaySpeed: 0.0008, size: 7.5 },
    { id: 5, hue: 48, swayOffset: 4, swaySpeed: 0.00055, size: 7 },
    { id: 6, hue: 38, swayOffset: 5, swaySpeed: 0.00065, size: 6.8 },
    { id: 7, hue: 52, swayOffset: 6, swaySpeed: 0.00075, size: 7.2 },
  ];

  useEffect(() => {
    let animationFrame: number;
    const animate = () => {
      setTime(performance.now());
      animationFrame = requestAnimationFrame(animate);
    };
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        background:
          "radial-gradient(circle at 50% 80%, #1a1f4e 0%, #0a0e29 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {lanterns.map((lantern) => (
        <Lantern key={lantern.id} lantern={lantern} time={time} />
      ))}
    </div>
  );
}
